import { ISidebarItem } from "src/components/NavigationSidebar/types";
import { PATHNAMES } from "src/constants/routes";
import { Roles } from "src/@types/users";
import { cabinetNavigationSidebarTrns, cabinetTrns } from "./trns";
import { ICabinetData } from "./types";

const AGENT_CABINET_SIDEBAR_ITEMS: ISidebarItem[] = [
  {
    id: "1",
    title: { i18nKey: cabinetNavigationSidebarTrns.myClones },
    href: PATHNAMES.MY_CLONES,
  },
  {
    id: "2",
    title: { i18nKey: cabinetNavigationSidebarTrns.deals },
    href: PATHNAMES.DEALS,
  },
  {
    id: "3",
    title: { i18nKey: cabinetNavigationSidebarTrns.myInquiries },
    href: PATHNAMES.MY_INQUIRIES,
  },
  {
    id: "4",
    title: { i18nKey: cabinetNavigationSidebarTrns.watchlist },
    href: PATHNAMES.FAVOURITE_INQUIRIES,
  },
  {
    id: "5",
    title: { i18nKey: cabinetNavigationSidebarTrns.favorites },
    href: PATHNAMES.FAVORITES_CLONES,
  },
  {
    id: "6",
    title: { i18nKey: cabinetNavigationSidebarTrns.settings },
    href: PATHNAMES.SETTINGS,
  },
];

const OWNER_CABINET_SIDEBAR_ITEMS: ISidebarItem[] = [
  {
    id: "1",
    title: { i18nKey: cabinetNavigationSidebarTrns.myClones },
    href: PATHNAMES.MY_CLONES,
  },
  {
    id: "2",
    title: { i18nKey: cabinetNavigationSidebarTrns.watchlist },
    href: PATHNAMES.FAVOURITE_INQUIRIES,
  },
  {
    id: "3",
    title: { i18nKey: cabinetNavigationSidebarTrns.deals },
    href: PATHNAMES.DEALS,
  },
  {
    id: "4",
    title: { i18nKey: cabinetNavigationSidebarTrns.settings },
    href: PATHNAMES.SETTINGS,
  },
];

export const CABINET_DATA: ICabinetData = {
  [Roles.AGENT]: {
    title: { i18nKey: cabinetTrns.agentCabinetTitle },
    sidebarItems: AGENT_CABINET_SIDEBAR_ITEMS,
  },
  [Roles.OWNER]: {
    title: { i18nKey: cabinetTrns.ownerCabinetTitle },
    sidebarItems: OWNER_CABINET_SIDEBAR_ITEMS,
  },
};
